import { Observable } from 'rxjs';
import { BaseService } from '../../../../core/services/base.service';
import { PageResponse } from '../../../../core/interfaces/page-response.interface';
import { TeamInterviewerItem, TeamItem, TeamMemberItem, TeamUpsertPayload } from '../../interfaces/team/team.interface';

export abstract class TeamService extends BaseService<TeamItem> {
    abstract override findAll(searchParam: any): Observable<PageResponse<TeamItem>>;
    abstract override find(id: string): Observable<TeamItem>;
    abstract override create(data: Partial<TeamItem>): Observable<TeamItem>;
    abstract override update(id: string, data: Partial<TeamItem>): Observable<TeamItem>;
    abstract override delete(id: string): Observable<void>;

    abstract getTeams(params?: any): Observable<TeamItem[]>;
    abstract getTeamMembers(teamUniqueId: string, params?: any): Observable<TeamMemberItem[]>;
    abstract getInterviewers(params?: any): Observable<TeamInterviewerItem[]>;
    abstract createOrUpdate(payload: TeamUpsertPayload): Observable<TeamItem>;
}
